import ProfilePage from './components';
import { BasePaths, pageName } from './constants';
import reducers from './reducers';
import renderPage from '../config/renderPage';
import { gaPageViewMiddleware, dataLakeMiddleware } from '../middleware/pageView';
import analytics from './analytics';

const el = document.getElementById('main');

renderPage({
    el,
    reducers,
    initialState: window.__REDUX_STATE__,
    routes: BasePaths.map(path => ({
        path,
        component: ProfilePage,
    })),
    pageName,
    preGaCustomMiddleware: [
        gaPageViewMiddleware(analytics, window.location),
        dataLakeMiddleware(window.location, window.document, analytics),
    ],
});
